import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'
import { store } from '../_helpers/store'
import { authHeader } from '../_helpers/auth-header'

export const clientService = {
  getInfo,
  enableIntake,
  retrieveServices,
};

function getInfo(authToken, clientId) {
  return axiosInstance.request({
    method: 'GET',
    headers: { 'Authorization': `Bearer ${authToken}` },
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/info`,
  }).then(response => {
    return response.data
  });
}

function enableIntake() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/service/axs-intake`,
  }).then(response => {
    return response.data.data
  });
}

function retrieveServices() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/service`,
  }).then(response => {
    return response.data.data
  });
}